<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="update">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="isItemFound()">
              <select-ticket-root-type-action-types v-model="type" :options="{ id: 'type', label: 'type', params: { ticketId: id, typeId: type_id }, error: fieldErrors.type }"/>
            </div>
            <div class="row" v-if="isItemFound()">
              <input-checkbox v-model="is_auto" :options="{ id: 'is_auto', label: 'is_auto', error: fieldErrors.isAuto }"/>
              <input-checkbox v-model="enabled" :options="{ id: 'enabled', label: 'enabled', error: fieldErrors.enabled }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button v-if="isItemFound()" type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { TICKETS_ROOTS_TYPES_ACTIONS_SHOW as CRUD_ACTION_SHOW,TICKETS_ROOTS_TYPES_ACTIONS_UPDATE as CRUD_ACTION_UPDATE } from 'actions/tickets';
  const TICKETS_CODE="tickets";
  const TICKETS_ROOTS_CODE=`${TICKETS_CODE}.roots`;
  const TICKETS_ROOTS_TYPES_CODE=`${TICKETS_ROOTS_CODE}.types`;
  const CRUD_CODE=`${TICKETS_ROOTS_TYPES_CODE}.actions`;
  export default {
    name: "TicketRootTypeActionEdit",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        ticketsRoutePrefix: TICKETS_CODE,
        ticketsTransPrefix: TICKETS_CODE,
        ticketRootsRoutePrefix: TICKETS_ROOTS_CODE,
        ticketRootsTransPrefix: TICKETS_ROOTS_CODE,
        ticketRootTypesRoutePrefix: TICKETS_ROOTS_TYPES_CODE,
        ticketRootTypesTransPrefix: TICKETS_ROOTS_TYPES_CODE,
        id:this.$router.currentRoute.params.id,
        type_id:this.$router.currentRoute.params.type_id,
        action_id:this.$router.currentRoute.params.action_id,
        type: '',
        is_auto: false,
        enabled: false,
        serverError: '',
        fieldErrors: {},
        responseStatus:'',
        formMode: 'edit',
        loading: false,
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      isItemFound(){
        return this.responseStatus!==404;
      },
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          ticketId: this.id,
          typeId: this.type_id,
          id: this.action_id,
        }).then(response=>{
          this.type=response.data.type;
          this.is_auto=response.data.isAuto;
          this.enabled=response.data.enabled;
        }).catch(error => {
          this.loading = false;
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
      prepareRequestData(){
        return {
          type: this.sanitizeField('type'),
          isAuto: this.sanitizeField('is_auto'),
          enabled: this.sanitizeField('enabled'),
        }
      },
      update() {
        this.loading = true;
        this.$store.dispatch(CRUD_ACTION_UPDATE, {
          id: this.action_id,
          typeId: this.type_id,
          ticketId: this.id,
          data: {
            ...this.prepareRequestData()
          },
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.update_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.routePrefix}.index` })
        })
        .catch(error => {
          this.loading = false;
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      }
    },
  };
</script>
